// ABOUTME: Inline activity text rendered in the viewer's language with a translation badge.
// ABOUTME: Used on calendar/library/plan cards, where space only allows a hover-revealed original.

import type { L10nFragment } from "@/graphql/main/gql/graphql"
import { L10nBadge } from "./L10nBadge"
import { resolveL10n } from "./fn"

interface IProps {
  value: L10nFragment | null | undefined
  /** Plain original field — rendered when the L10n sibling is absent. */
  fallback?: string | null
  /** Rendered instead of an empty text, e.g. "-" on a card. */
  placeholder?: string
  /**
   * Element to render. Match whatever the surrounding card used before, and
   * never add a `display` utility (block/inline-block) to `className` on top of
   * a `line-clamp-*` one: line clamping relies on `display: -webkit-box`, and a
   * competing display kills the truncation.
   */
  as?: "span" | "div"
  className?: string
  badgeSize?: number
}

export const L10nText = ({ value, fallback, placeholder, as: Tag = "span", className = "", badgeSize }: IProps) => {
  const { display, original, badge } = resolveL10n(value, fallback)

  return (
    <Tag className={className}>
      {display || placeholder || ""}
      {badge !== "none" && (
        <L10nBadge
          kind={badge}
          original={original}
          size={badgeSize}
          className="ml-1"
        />
      )}
    </Tag>
  )
}

export default L10nText
